var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1243,
    height: 305,
    viewBox: "0 0 1243 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 23,
    r: 3,
    transform: "rotate(-90 469 23)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 74,
    r: 3,
    transform: "rotate(-90 1240 74)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 785,
    cy: 26,
    r: 3,
    transform: "rotate(-90 785 26)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1061,
    cy: 10,
    r: 3,
    transform: "rotate(-90 1061 10)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 925,
    cy: 98,
    r: 3,
    transform: "rotate(-90 925 98)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1133,
    cy: 198,
    r: 3,
    transform: "rotate(-90 1133 198)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 246,
    r: 3,
    transform: "rotate(-90 989 246)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 41,
    r: 3,
    transform: "rotate(-90 290 41)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 126,
    r: 3,
    transform: "rotate(-90 136 126)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 226,
    r: 3,
    transform: "rotate(-90 240 226)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 3,
    r: 3,
    transform: "rotate(-90 42 3)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 199,
    r: 3,
    transform: "rotate(-90 3 199)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 302,
    r: 3,
    transform: "rotate(-90 126 302)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 183,
    r: 3,
    transform: "rotate(-90 334 183)",
    fill: "white",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.dad9a58b4a31e6c784f8f5a3a15944c9.svg";
export { ForwardRef as ReactComponent };